import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IAdditionalItemInformation } from '@rbi-ctg/menu';

interface IAdditionalItemInfoProps {
  additionalInfo?: IAdditionalItemInformation;
}

const StyledText = styled.p`
  font-weight: bold;
  margin: 0;
`;

const StyledSpan = styled.span`
  margin-left: 0.5rem;
  font-weight: normal;
`;

const AdditionalInfoContainer = styled.div`
  p + p {
    margin-top: 10px;
  }
`;

export const StyledAdditionalInfo = ({ additionalInfo }: IAdditionalItemInfoProps) => {
  const { formatMessage } = useIntl();

  return (
    <AdditionalInfoContainer>
      {additionalInfo?.additives?.locale ? (
        <StyledText>
          {formatMessage({ id: 'additionalInfoAdditives' })}:{' '}
          <StyledSpan>{additionalInfo.additives.locale}</StyledSpan>
        </StyledText>
      ) : null}
      {additionalInfo?.ingredients?.locale ? (
        <StyledText>
          {formatMessage({ id: 'additionalInfoIngredients' })}:
          <StyledSpan>{additionalInfo.ingredients.locale}</StyledSpan>
        </StyledText>
      ) : null}
      {additionalInfo?.producerDetails?.locale ? (
        <StyledText>
          {formatMessage({ id: 'additionalInfoProducerDetails' })}:
          <StyledSpan>{additionalInfo.producerDetails.locale}</StyledSpan>
        </StyledText>
      ) : null}
    </AdditionalInfoContainer>
  );
};
